module.exports = __webpack_public_path__ + "img/none.bf860910.jpg";